export default {
  freeTimesLimitTitle: 'Die kostenlose Testversion ist heute abgelaufen.',
  fileSizeLimitTitle:
    'Die Dateigröße darf in der kostenlosen Version 20 MB nicht überschreiten.',
  total: 'Gesamt',
  enterCode: 'Code eingeben',
  signUpToPurchaseBtn: 'Anmelden und kaufen',
  goPurchseBtn: 'Zum Einkaufen gehen',
  saveTips: 'Sparen Sie bis zu {{num}}%',
  discount: 'Rabatt',
  weekly: 'Wöchentlich',
  montly: 'Monatlich',
  yearly: 'Jährlich',
  week: 'Woche',
  priceWeek: '9,99€',
  priceMonth: '7,49€',
  priceYearly: '3,75€',
  billMonth: '29,99€ Monatlich abgerechnet',
  billYear: '179,99€ Monatlich abgerechnet',
  AlreadySubscribe: 'Bereits abonniert?',
  vipTips1: 'Keine Dateigrößenbeschränkung',
  vipTips2: 'Keine Begrenzung der Anzahl der verarbeiteten Dateien',
  vipTips3: 'Bildhintergründe unbegrenzt ändern',
  vipTips4: 'Zugang zu allen kostenlosen Tools und Premium-Funktionen',
  purchaseTips: 'Automatische Verlängerung und jederzeitige Kündigung.',
  tips: 'Hinweise:',
  promoCodeInvalidTips: 'Ihr Promo-Code ist ungültig',
};
